import React, { useState, useEffect, useContext } from 'react';
import { styled } from '@mui/material/styles';
import { Link as RouterLink, Route } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { AppContext } from '@/AppContext';
import { Link, MenuItem, TextField } from '@mui/material';
import { dateFormat } from '../../VisitorList/components/ExportXLS/ExportXLS';
import ChatView from './chat/ChatView';

const PREFIX = 'ChatLogHistory';

const classes = {
  root: `${PREFIX}-root`,
};

const StyledChatView = styled(ChatView)(({ theme }) => ({
  [`& .${classes.root}`]: {
    flexGrow: 1,
  },
}));

const ChatLogHistory = props => {
  const appContext = useContext(AppContext);
  const { mid: meetupId, channelId, clientId } = useParams();

  const [refreshCounter, setRefresh] = useState(0);
  // const [history, setHistory] = useState(null);
  // useEffect(() => {
  //   appContext.chatLogsApi.listClientLogs(meetupId, channelId, clientId).then(({data}) => {
  //     setHistory(data)
  //   }).catch( appContext.errorHandler )
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [meetupId, clientId, refreshCounter]);

  const [threads, setThreads] = useState(null);

  useEffect(() => {
    const fetchThreads = async () => {
      try {
        let clients = (await appContext.chatLogsApi.getClients(meetupId)).data;
        let data = {};
        for (let client of clients) {
          data[client.chatId.chatClientId] = {};
          data[client.chatId.chatClientId].name = client.chatUserName;
          data[client.chatId.chatClientId].link = client.channel.channelLink;
          data[client.chatId.chatClientId].clientId = client.chatId.chatClientId;
          data[client.chatId.chatClientId].chatConfigId = client.chatId.chatConfigId;
          data[client.chatId.chatClientId].tgUsername = client.chatId.username;
        }

        let chatHistories = await Promise.all(
          clients.map(client =>
            appContext.chatLogsApi.listClientLogs(meetupId, client.chatId.chatConfigId, client.chatId.chatClientId)
          )
        );
        for (let client of chatHistories) {
          client = client.data;
          data[client.chatId.chatClientId].messages = client.messages;
        }

        setThreads(data);
      } catch (err) {
        console.log(err);
        appContext.errorHandler(err);
      }
    };
    fetchThreads();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetupId, refreshCounter]);

  if (!threads) {
    return null;
  }

  return <StyledChatView threads={threads} />;
};

export default ChatLogHistory;
